export default __webpack_public_path__ + "static/wave2-mobile-f6d483843c8232fbe6086db103df6010.png";